package de.oevbs.kunde.kundenportal2.components

import de.oevbs.sfa.communication.ServiceMessage
import dev.fritz2.core.Handler
import dev.fritz2.core.RootStore
import kotlinx.coroutines.Job

/**
 * Globaler Store zum Sammeln von [ServiceMessage]s, die vom Backend gesendet werden und _seitenübergreifend_
 * gerendert werden sollen.
 *
 * Die Messages des globalen Service-Message-Stores werden im [headerImageLayout] automatisch gerendert.
 *
 * __WIchtig:__ Die Messages werden vom [headerImageLayout] automatisch geleert, wenn dieses gerendert wird.
 *
 * @see headerImageLayout
 */
object GlobalServiceMessagesStore : RootStore<List<GlobalServiceMessagesStore.Entry>>(initialData = emptyList(), Job()) {

    /**
     * Eintrag im globalen Message-Store.
     *
     * Hauptbestandteil ist die [message].
     *
     * Optional kann der Eintrag als [sticky] markiert werden. In diesem Fall bleibt die Nachricht auch nach einem
     * [clear] Aufruf im Store bestehen, bis der Store mittels [forceClear] geleert wird. Dies ist bspw. dann der
     * Fall, wenn der Nutzer eingeloggt ist und eine Seite mit einem [headerImageLayout] ansteuert.
     *
     * Die Verwendung von [sticky] kann sinnvoll sein, um besonders wichtige Meldungen seitenübergreifend, ungeachtet
     * des Verhaltens der eigentlichen Seite, hervorzuheben und beizubehalten.
     */
    data class Entry(
        val message: ServiceMessage,
        val sticky: Boolean = false
    )

    val add: Handler<ServiceMessage> = handle { entries, new ->
        entries + Entry(new)
    }

    val addSticky: Handler<ServiceMessage> = handle { entries, new ->
        entries + Entry(new, sticky = true)
    }

    val addList: Handler<List<ServiceMessage>> = handle { entries, list ->
        entries + list.map(::Entry)
    }

    val clear: Handler<Unit> = handle { messages ->
        messages.filter(Entry::sticky)
    }

    val forceClear: Handler<Unit> = handle {
        emptyList()
    }
}